import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faCalendar, faStar, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import ExperienceTimelineCard from './ExperienceTimelineCard';

const iconMap = {
  urgent: faBolt,
  calendar: faCalendar,
  star: faStar
};

export default function TimelineSection({ title, subtitle, icon, experiences, type, highlight = false }) {
  const IconComponent = iconMap[icon] || faCalendar;

  return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`
        ${highlight ? 'bg-gradient-to-br from-accent/5 to-primary/5 rounded-3xl p-6 md:p-8 border-2 border-accent/20' : ''}
      `}
    >
      {/* Section Header */}
      <div className="flex items-center gap-3 mb-6">
        <div className={`
          text-3xl md:text-4xl
          ${highlight ? 'animate-pulse' : ''}
        `}>
          <FontAwesomeIcon icon={IconComponent} className={highlight ? 'text-accent' : 'text-primary'} />
        </div>
        <div>
          <h2 className="text-2xl md:text-3xl font-sans font-semibold text-text-primary tracking-tighter" style={{ letterSpacing: '-0.05em' }}>
            {title}
          </h2>
          <p className="text-sm md:text-base text-text-secondary">
            {subtitle}
          </p>
        </div>
        {highlight && (
          <div className="ml-auto">
            <span className="bg-accent text-white text-xs font-bold px-3 py-1 rounded-full animate-pulse flex items-center gap-1">
              <FontAwesomeIcon icon={faExclamationTriangle} className="w-3 h-3" />
              URGENT
            </span>
          </div>
        )}
      </div>

      {/* Timeline Line (Desktop) */}
      <div className="hidden md:block relative">
        {/* Vertical line */}
        <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary via-primary/50 to-transparent" />
        
        {/* Experience Cards */}
        <div className="space-y-6">
          {experiences.map((exp, index) => (
            <ExperienceTimelineCard
              key={exp.id}
              experience={exp}
              type={type}
              index={index}
            />
          ))}
        </div>
      </div>

      {/* Mobile: Stack without timeline line */}
      <div className="md:hidden space-y-4">
        {experiences.map((exp, index) => (
          <ExperienceTimelineCard
            key={exp.id}
            experience={exp}
            type={type}
            index={index}
            mobile={true}
          />
        ))}
      </div>
    </motion.section>
  );
}

